import { updateViewedProductsByHandle } from '@/components/helpers/product'

function handleProductLoad () {
  if (typeof window.productHandle === 'undefined') return
  updateViewedProductsByHandle(window.productHandle)
}

handleProductLoad()
